declare global {
  interface Window {
    dataLayer: any[];
    gtag: (...args: any[]) => void;
  }
}

interface GtagItem {
  item_id: string;
  item_name: string;
  price?: number;
  quantity?: number;
}

interface GtagPurchaseParams {
  transaction_id: string;
  value: number;
  currency: string;
  items: GtagItem[];
}

interface GtagAddToCartParams {
  currency: string;
  value: number;
  items: GtagItem[];
}

interface GtagBeginCheckoutParams {
  currency: string;
  value: number;
  items: GtagItem[];
}

class GtagService {
  private static instance: GtagService;
  private initialized: boolean = false;

  private constructor() {}

  public static getInstance(): GtagService {
    if (!GtagService.instance) {
      GtagService.instance = new GtagService();
    }
    return GtagService.instance;
  }

  public init(): void {
    if (this.initialized) {
      return;
    }

    // Check if gtag is available and is a function
    if (typeof window !== 'undefined' && typeof window.gtag === 'function') {
      this.initialized = true;
    }
  }

  private ensureInitialized(): void {
    if (!this.initialized) {
      this.init();
    }
  }

  /**
   * Track purchase conversion
   */
  public trackPurchase(params: GtagPurchaseParams): void {
    this.ensureInitialized();
    
    if (typeof window !== 'undefined' && typeof window.gtag === 'function') {
      window.gtag('event', 'purchase', {
        transaction_id: params.transaction_id,
        value: params.value,
        currency: params.currency,
        items: params.items
      });
    }
  }

  /**
   * Track add to cart conversion
   */
  public trackAddToCart(params: GtagAddToCartParams): void {
    this.ensureInitialized();
    
    if (typeof window !== 'undefined' && typeof window.gtag === 'function') {
      window.gtag('event', 'add_to_cart', {
        currency: params.currency,
        value: params.value,
        items: params.items
      });
    }
  }

  /**
   * Track begin checkout conversion
   */
  public trackBeginCheckout(params: GtagBeginCheckoutParams): void {
    this.ensureInitialized();
    
    if (typeof window !== 'undefined' && typeof window.gtag === 'function') {
      window.gtag('event', 'begin_checkout', {
        currency: params.currency,
        value: params.value,
        items: params.items
      });
    }
  }

  /**
   * Track page view
   */
  public trackPageView(page_path?: string, page_title?: string): void {
    this.ensureInitialized();
    
    if (typeof window !== 'undefined' && typeof window.gtag === 'function') {
      window.gtag('event', 'page_view', {
        page_path: page_path || window.location.pathname,
        page_title: page_title || document.title
      });
    }
  }
}

export const gtagService = GtagService.getInstance();

